import { dbh_ajax } from "Ressources/dbh_ajax";
import { dbh_helper } from "../src/dbh_helper";
import { dbh_loading } from "../src/dbh_loading";

export class dbh_filePreview {

    public zoomImg = ($element, zoom: number) => {
        const $img = $element.closest(".dbh_filePreviewContainer").find("img");
        const $fileContent = $element.closest(".dbh_filePreviewContainer").find(".fileContent");
        const currWidth = $img.width();

        /* Container darf beim Zoomen des Bildes nicht größer werden */
        const containerHeigth = $fileContent.outerHeight();
        $fileContent.css("maxHeight", `${containerHeigth}px`)
        $fileContent.css("minHeight", `${containerHeigth}px`);
        $fileContent.css("overflow", `auto`);

        const newWidth = currWidth + zoom;

        /*Maximale Größen prüfen*/
        if ((zoom < 0 && newWidth < 100)
            || zoom > 0 && newWidth > 2500) {
            return false;
        }
        else {
            $img.width(newWidth);
        }

        const containerWidth = $fileContent.outerWidth();

        /*Je nach größe des Bildes, wird dessen Eigenschaften angepasst*/
        if (newWidth <= containerWidth) {
            $img.css("position", "");
            $img.css("margin", "auto");
        } else {
            $img.css("position", "absolute");
            $img.css("left", "0");
        }

    }

    public loadPrevNextImage = (id, isAufgabe) => {
        var loading: dbh_loading = new dbh_loading();

        loading.onLoading('previewContainer');
        $(`#previewContainer`).html("");

        dbh_helper.SendGetRequest("GetPdfOrImgPreview", "Home", [['id', id]], '#previewContainer', function () {
            if ($(".filePreviewImage").length > 0) {
                $(".filePreviewImage").on("load", function () {
                    loading.onLoadingFinished();
                });
            } else {
                loading.onLoadingFinished();
            }
        });
    }

    public initTurnRight = () => {
        $(document).on("click", ".turnRight", function () {
            var loading: dbh_loading = new dbh_loading();
            const id = $(this).data("id");
            const isAufgabe = $(this).data("isaufgabe");

            loading.onLoading('previewContainer');
            $(`#previewContainer`).html("");

            dbh_helper.SendGetRequest("TurnImgOrFileBy90Degree", "Home", [['id', id]], '#previewContainer', function () {
                if ($(".filePreviewImage").length > 0) {
                    $(".filePreviewImage").on("load", function () {
                        loading.onLoadingFinished();
                    });
                } else {
                    loading.onLoadingFinished();
                }
            });
        });
    };

}

$(document).ready(function () {

});